import React, { FunctionComponent, PropsWithChildren } from "react";

export interface RTLWrapperProps extends PropsWithChildren {
	inline?: boolean;
}

const RTLWrapper: FunctionComponent<RTLWrapperProps> = (props) => {
	const { children, inline } = props;
	return (
		inline ? (
			<span dir="rtl">
				{children}
			</span>
		) : (
			<div dir="rtl">
				{children}
			</div>
		)
	);
};

export default RTLWrapper;